module.exports = __webpack_public_path__ + "img/loading.21a1ae6d.svg";